<div class="h-100">
  <div class="nav border-bottom">
    @for (tabComponent of tabComponents; track tabComponent) {
      @if (tabComponent.tab.readPermissions | hasRole) {
        <div
          class="nav-item">
          <a
            role="button"
            class="nav-link text-nowrap"
            [class.active]="currentTab === tabComponent.tab"
            tabindex="0"
            (keyup.enter)="setTab(tabComponent.tab)"
            (click)="setTab(tabComponent.tab)">{{ tabComponent.tab.name }}</a>
        </div>
      }
    }
  </div>
  <ng-content></ng-content>
</div>
